import * as yup from 'yup';
import { useValidation } from '../../../../hooks/useValidation';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import TextInput from '../../TextInput';
import FormRow from '../../../Form/Row';
import Select from '../../Select';
import { MapPin } from 'react-feather';
import TextArea from '../../TextArea';
import Button from '../../../Button';
import Heading from '../../../Typography/Heading';
import { TypePill } from '../../../Card/Experience';
import TrueFalseInput from '../../TrueFalseInput';
import { usePlaceholder } from '../../../../hooks/usePlaceholder';
export var todayDate = { value: 'today', label: "Aujourd'hui" };
var ExperienceForm = function (_a) {
    var onSubmit = _a.onSubmit, type = _a.type, defaultValues = _a.defaultValues, _b = _a.removable, removable = _b === void 0 ? false : _b, onDelete = _a.onDelete, _c = _a.defaultHighlighted, defaultHighlighted = _c === void 0 ? false : _c;
    var _d = useValidation(), textOptional = _d.textOptional, textRequired = _d.textRequired, booleanNullable = _d.booleanNullable, objectRequired = _d.objectRequired;
    var placeholders = usePlaceholder();
    var schema = yup.object().shape({
        type: objectRequired,
        start_year: textRequired,
        end_year: textRequired,
        company: textOptional,
        position: textRequired,
        location: textRequired,
        description: textOptional,
        highlighted: booleanNullable,
    });
    var _e = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultValues || { type: type, highlighted: defaultHighlighted },
    }), handleSubmit = _e.handleSubmit, control = _e.control, watch = _e.watch;
    //Function to generate an array of years from the current year to the current year - 100
    //Takes a min or max year as optional parameters
    //Example: [{value: 2020, label: 2020}, {value: 2019, label: 2019}, ...]
    var generateYears = function (_a) {
        var min = _a.min, max = _a.max, today = _a.today;
        var currentYear = String(new Date().getFullYear());
        if (min === 'today')
            min = currentYear;
        if (max === 'today')
            max = currentYear;
        var minYear = min ? min : Number(currentYear) - 100;
        var maxYear = max ? max : Number(currentYear);
        var years = [];
        for (var i = Number(maxYear); i >= Number(minYear); i--) {
            years.push({ value: i.toString(), label: i.toString() });
        }
        if (today) {
            years.unshift(todayDate);
        }
        return years;
    };
    var handleDelete = function () {
        onDelete && onDelete();
    };
    return (<form onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col">
        <div className="px-drawer-lg mb-6 flex flex-col gap-1.5 md:mb-8">
          <Heading level={3} type="h6">
            Ajouter une expérience
          </Heading>
          <TypePill type={type}/>
        </div>
        <div className="px-drawer-lg flex flex-col gap-6 pb-12">
          {!defaultHighlighted && (<FormRow>
              <TrueFalseInput label="Mettre en avant cette expérience sur votre profil" name="highlighted" control={control} defaultValue={false}/>
            </FormRow>)}
          <FormRow>
            <Select label="Année de début" name="start_year" control={control} required placeholder={placeholders.startYear} choices={generateYears({ max: watch('end_year') })}/>
            <Select label="Année de fin" name="end_year" control={control} required placeholder={placeholders.endYear} choices={generateYears({ min: watch('start_year'), today: true })}/>
          </FormRow>
          <FormRow>
            <TextInput name="company" control={control} placeholder={placeholders.company} label="Entreprise / Organisme / École"/>
          </FormRow>
          <FormRow>
            <TextInput name="position" control={control} placeholder={placeholders.position} label="Intitulé du poste / Mission / Diplôme" required/>
          </FormRow>
          <FormRow>
            <TextInput name="location" control={control} placeholder={placeholders.location} label="Lieux" icon={MapPin} required/>
          </FormRow>
          <FormRow>
            <TextArea name="description" control={control} placeholder={placeholders.experienceDescription} label="Description" max={200}/>
          </FormRow>
        </div>
        <div className="px-drawer-lg sticky bottom-0 left-0 flex flex-col gap-4 bg-white py-4 shadow-spread sm:pt-8 sm:pb-4">
          <Button submit className="w-full">
            {defaultValues ? 'Modifier' : 'Ajouter'}
          </Button>
          {removable && onDelete && (<Button type="inline" onClick={handleDelete} alert="danger">
              Supprimer l'expérience
            </Button>)}
        </div>
      </div>
    </form>);
};
export default ExperienceForm;
